<section class="control-bar">
  <!-- in case you remove on of them you can use class="item-4" instead of class="item-5" -->
  <div class="item item-5" routerLink="/home/requests" routerLinkActive="active">
    <a>
      <div class="icon my_requests"></div>
      <p>
        تسعيراتي
      </p>
    </a>
  </div>
  <div class="item item-5" routerLink="/home/orders" routerLinkActive="active">
    <a>
      <div class="icon my_orders"></div>
      <p>
        مشترياتي
      </p>
    </a>
  </div>
  <div class="item item-5 active new-order-button">
    <a>
      <div class="icon new_order"></div>
      <p class="shared">
        <a class="shared" routerLink="/home/new-request">طلب جديد</a>
      </p>
    </a>
  </div>
  <div class="item item-5" routerLink="/home/notifications" routerLinkActive="active">
    <a>
      <div class="icon notifications"></div>
      <p>
        التنبيهات
      </p>
    </a>
  </div>
  <div class="item item-5" routerLink="/home/profile" routerLinkActive="active">
    <a>
      <div class="icon my_account"></div>
      <p>
        حسابي
      </p>
    </a>
  </div>
</section>
